import styled from 'styled-components'
import { Box, theme } from '@mrshmllw/smores-react'

export const StickyButtonContainer = styled(Box)`
  position: sticky;
  margin-top: 32px;
  width: 100%;
  bottom: 0;
  background-color: ${theme.colors.cream};
  box-shadow: 0px -2px 10px rgba(0, 0, 0, 0.1);
  z-index: 5;
`

export const FixedButtonContainer = styled(Box)`
  position: fixed;
  margin-top: 32px;
  width: 100%;
  bottom: 0;
  background-color: ${theme.colors.cream};
  box-shadow: 0px -2px 10px rgba(0, 0, 0, 0.1);
  z-index: 5;
`
